import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../AppProvider';
import PageLayout from "../PageLayout";
import { apiRequest } from "../utils/Axios";

const ComponentSoal = () => {
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);

    const handleRequest = async () => {
        setData(null); setError(null);

        setTimeout(async () => {
            try {
                const result = await apiRequest('GET', '/user', {});
                if (result.code === 'ok') {
                    setData(result.data);
                } else {
                    setError(result || 'Kesalahan terjadi!');
                }
            } catch (e) {
                setError({msg : 'Kesalahan terjadi!'});
            }
        }, 3000); 
    };

    useEffect(() => {
        handleRequest();        
    }, []);

    // Skeleton Component
    const Skeleton = () => {
        return (
        <button className="flex btn btn-ghost rounded-2xl px-4 py-3 h-auto">
            <div className="text-start w-full">
                <div className="skeleton h-4 w-1/4"></div>
                <div className="skeleton h-6 w-full my-2"></div>
                <div className="skeleton h-4 w-1/2"></div>
            </div>
        </button>
        )
    }

    // Item Component
    const Item = ({key, data}) => {
        return (
        <button key={key} className="flex btn btn-ghost rounded-2xl px-4 py-3 h-auto">
            <div className="text-start text-base font-light w-full">
                {data.kode_kelas && <span className='text-xs text-opacity-50'>{data.kode_kelas}</span>}
                <h2 className="font-semibold">{data.nama}</h2>
                <p className="text-sm">{data.nis}</p>
            </div>
        </button>
        )
    }
    // Item Error Component
    const ItemError = ({key, data}) => {
        return (
        <button key={key} className="flex btn btn-ghost rounded-2xl px-4 py-3 h-auto">
            <div className="text-start text-base font-light w-full">                
                <h2 className="font-semibold">Terjadi Kesalahan</h2>
                <p className="text-sm">{data.msg}</p>
            </div>
        </button>
        )
    }

    // Layout Component
    return (
    <section className="grid gap-2">
        <div className="flex items-center gap-2 px-4 py-3 pb-0">
            <h2 className="flex-grow text-xl font-semibold">Soal Ujian</h2>
            <button className="btn btn-ghost btn-xs text-base-content" onClick={handleRequest}>
                Segarkan
            </button>
        </div>
        <div className="grid grid-cols-1 gap-2">
            {Array.isArray(data) && data.map(item => (
                <Item key={item.nis} data={item} />
            ))}
            {error && <ItemError data={error} />}
            {(!data && !error) && <Skeleton />}
        </div>
    </section>
    );
}

const ComponentStats = () => {
    const [error, setError] = useState(null);
    const [data, setData] = useState([]);

    const handleRequest = async () => {
        setData(null); setError(null);

        setTimeout(async () => {
            try {
                const result = await apiRequest('GET', '/user', {});
                if (result.code === 'ok') {
                    setData(result.data);
                } else {
                    setError(result || 'Kesalahan terjadi!');
                }
            } catch (e) {
                setError({msg : 'Kesalahan terjadi!'});
            }
        }, 3000); 
    };

    useEffect(() => {
        handleRequest();        
    }, []);

    // Skeleton Component
    const Skeleton = () => {
        return (
        <div className="stats text-base-content rounded-2xl bg-transparent">
            <div className="stat p-4">
                <div className="stat-title"><div className="skeleton h-4 w-10 my-2"></div></div>
                <div className="stat-value"><div className="skeleton h-10 w-20 my-2"></div></div>
                <div className="stat-desc"><div className="skeleton h-4 w-28 my-2"></div></div>
            </div>
            <div className="stat p-4">
                <div className="stat-title"><div className="skeleton h-4 w-10 my-2"></div></div>
                <div className="stat-value"><div className="skeleton h-10 w-20 my-2"></div></div>
                <div className="stat-desc"><div className="skeleton h-4 w-28 my-2"></div></div>
            </div>
        </div>
        )
    }

    // Item Component
    const Item = ({key, data}) => {
        return (
        <div key={key} className="stats text-base-content rounded-2xl bg-transparent">
            <div className="stat p-4">
                <div className="stat-title">Siswa</div>
                <div className="stat-value">{data.jumlah_siswa ? data.jumlah_siswa : 0}</div>
                <div className="stat-desc">Dalam kelas</div>
            </div>
            <div className="stat p-4">
                <div className="stat-title">Soal</div>
                <div className="stat-value">{data.jumlah_soal ? data.jumlah_soal : 0}</div>
                <div className="stat-desc">Akan dikerjakan</div>
            </div>
        </div>
        )
    }
    // Item Error Component
    const ItemError = ({key, data}) => {
        return (
        <div key={key} className="stats text-base-content rounded-2xl bg-transparent">
            <div className="stat p-4">
                <div className="stat-title">Siswa</div>
                <div className="stat-value">{data.jumlah_siswa ? data.jumlah_siswa : 0}</div>
                <div className="stat-desc">Dalam kelas</div>
            </div>
            <div className="stat p-4">
                <div className="stat-title">Soal</div>
                <div className="stat-value">{data.jumlah_soal ? data.jumlah_soal : 0}</div>
                <div className="stat-desc">Akan dikerjakan</div>
            </div>
        </div>
        )
    }

    // Layout Component
    return (
    <section className='grid gap-4'>
        {Array.isArray(data) && <Item data={data} />}
        {error && <ItemError data={error} />}
        {(!data && !error) && <Skeleton />}
    </section>
    );
}

const Home = () => {
    const { auth, userData } = useContext(AppContext);   

    return (
    <PageLayout>
        <section className="grid gap-4">
            <div className="px-4">
                <h2 className="text-xl font-semibold capitalize">
                    Hai, {userData.nama.toLowerCase().split(' ')[0]}!
                </h2>
                <p>Sudah siap untuk ujian?</p>
            </div>
        </section>
        <ComponentStats />
        <ComponentSoal />
    </PageLayout>
    );
};

export default Home;
